import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
const environment = process.env.REACT_APP_ENV;

const client = new LambdaClient({
  region: "me-south-1",
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  },
});
// Start pipeline (only function you need now)
export async function startBotAgent(payload) {
  const command = new InvokeCommand({
    FunctionName: environment === "prod" ? "Vendor_agent" : "bot_agent",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      tableName: payload?.table || "clearance",
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function startVccBotAgent(payload) {
  const files = (payload?.files || []).map((f) => ({
    name: f.name,
    mimetype: f.mimetype,
    base64: f.base64,
  }));

  const command = new InvokeCommand({
    FunctionName: environment === "prod" ? "vcc-agent-prod" : "vcc-agaent-stg",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      tableName: payload?.table || "vcc-upload",
      files,
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function startDeclarationBotAgent(payload) {
  const files = (payload?.files || []).map((f) => ({
    name: f.name,
    mimetype: f.mimetype,
    base64: f.base64,
  }));

  const command = new InvokeCommand({
    FunctionName: environment === "prod" ? "vcc-agent-prod" : "vcc-agaent-stg",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      tableName: payload?.table || "declration-upload",
      files,
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function runDeclarationBotAgent(payload) {
  const files = (payload?.files || []).map((f) => ({
    name: f.name,
    mimetype: f.mimetype,
    base64: f.base64,
  }));

  const command = new InvokeCommand({
    FunctionName:
      environment === "prod"
        ? "prod-vcc_lambda_execution"
        : "vcc_lambda_execution",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      tableName: payload?.table || "both",
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function runVccBotAgent(payload) {
  const files = (payload?.files || []).map((f) => ({
    name: f.name,
    mimetype: f.mimetype,
    base64: f.base64,
  }));

  const command = new InvokeCommand({
    FunctionName:
      environment === "prod"
        ? "prod-vcc_lambda_execution"
        : "vcc_lambda_execution",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      tableName: payload?.table || "vcc-execution",
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function startReconcilationBotAgent(payload) {
  const files = (payload?.files || []).map((f) => ({
    name: f.name,
    mimetype: f.mimetype,
    base64: f.base64,
  }));

  const command = new InvokeCommand({
    FunctionName: environment === "prod" ? "prod_reconcile_lambda" : "stg_reconcile_lambda",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      tableName: payload?.table || "bank_reconciles",
      payload,
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function startTTAgent() {
  const command = new InvokeCommand({
    FunctionName:
      environment === "prod" ? "prod_vehicle_tt_agent" : "stg_vehicle_tt_agent",
    InvocationType: "RequestResponse",
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function startUnAppliedFund(payload) {
  const command = new InvokeCommand({
    FunctionName:
      environment === "prod"
        ? "prod_vendor_unapplied_funds"
        : "stg_vendor_unapplied_funds",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      ...payload,
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}

export async function startPrepaidAgent(payload) {
  const command = new InvokeCommand({
    FunctionName:
      environment === "prod"
        ? "prod_vehicle_prepaid"
        : "stg_vehicle_prepaid",
    InvocationType: "RequestResponse",
    Payload: JSON.stringify({
      ...payload,
    }),
  });

  const response = await client.send(command);
  return JSON.parse(new TextDecoder().decode(response.Payload));
}
